import { VerifyEmail } from '../components/VerifyEmail';

export const VerifyLink = () => <VerifyEmail />;
